WiseMetering.Views.DisableEtl = WiseMetering.Views.Modal.Custom.extend({
    className: 'mbx-info',
    buttons: ['yes', 'no'],
    form_prefix: 'etl',
    template: 'templates/etls/disable',
    title: 'Disable Etl',

    yes: function() {
        this.block();
        let success = function() {
            WiseMetering.layout.showTipper('success', 'Successfully disabled etl');
            this.unblock();
            this.close();
        }.bind(this);
        let error = function() {
            WiseMetering.layout.showTipper('error', 'Unable to disable etl');
            this.unblock();
            this.close();
        }.bind(this);

        this.model.disable({
            success: success.bind(this),
            error: error.bind(this)
        }).then(data => {
            this.model.set(data);
            this.options.callback();
        });
    }
});
